export const refreshPage = () => {
    window.location.reload();
}

export const shuffle = (array) => {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }

    return array;
}

export const getRandomArbitrary = (min, max) => {
    let random = Math.random() * (max - min) + min;
    return Math.floor(random);
}

export function getInstanceMethods(obj) {
    const reactInternals = [
        "constructor",
        "render",
        "componentDidMount",
        "componentDidUpdate",
        "componentWillUnmount",
        "componentDidCatch",
        "shouldComponentUpdate",
        "getSnapshotBeforeUpdate",
        "UNSAFE_componentWillMount",
        "UNSAFE_componentWillUpdate",
        "UNSAFE_componentWillReceiveProps",
        "isMounted", // deprecated!
        "setState",
        "forceUpdate",

        "onBetting",
        "setWinLose",
        "randomBonus",
        "refreshData",
        "preSetNewGame",
        "setNewGame",
        "checkDrawingResult",
        "subscription",
        "getRecentDraw",
        "clickAmountBetBtn",
        "resetDefaultAmount",
        "changeBetAmount",
        "isValidBetAmount",
        "submitBetNow",
        "onConfirmBettingLotto5",
        "onCancelBetting",
        "setBettingStatusByTimer",
        "countingSecond",
        "getResultDrawing",
        "getReleaseNum",
        "drawResult",
        "showResultRender",
        "onShowDetail",
        "onCloseDetail",
        "afterPrint",
        "onDrawStatusChange",
        "verifyCurrentDraw",
        "playAudio",
        "onCloseValidateBalance"
    ];

    const methods = {};
    let proto = obj;
    while (proto && proto !== Object.prototype) {
        Object.getOwnPropertyNames(proto).forEach((key) => {
            if (
                typeof obj[key] === "function" &&
                !reactInternals.includes(key) &&
                !key.startsWith("component") // catch lifecycle
            ) {
                methods[key] = obj[key].bind(obj);
            }
        });
        proto = Object.getPrototypeOf(proto);
    }
    return methods;
}

